import { useEffect, useState } from 'react';
import { LinkCard } from './LinkCard';
import { SearchableList } from '../shared/SearchableList';
import { initLinkService, Link } from './linkService';

export const LinksList = () => {
  const [links, setLinks] = useState<Link[]>([]);

  useEffect(() => {
    const linkService = initLinkService();
    linkService.getLinks().then(links => setLinks(links));
  }, []);

  return (
    <SearchableList
      pageKey="links"
      list={links}
      renderElement={(l: Link) => <LinkCard key={l.id} link={l} />}
    />
  );
}
